// Static fallback so we can render UI before /api/appreciations/types loads
export const APPRECIATION_TYPES = {
  TEAM_PLAYER:        { label: "Team Player",         emoji: "🤝", color: "#3B82F6" },
  FAST_DELIVERY:      { label: "Fast Delivery",       emoji: "🚀", color: "#F59E0B" },
  CREATIVE_GENIUS:    { label: "Creative Genius",     emoji: "🎨", color: "#EC4899" },
  PROBLEM_SOLVER:     { label: "Problem Solver",      emoji: "🧠", color: "#8B5CF6" },
  LEADERSHIP:         { label: "Leadership",          emoji: "🌟", color: "#F59E0B" },
  COMMUNICATION:      { label: "Excellent Communication", emoji: "💬", color: "#10B981" },
  DEADLINE_CHAMPION:  { label: "Deadline Champion",   emoji: "⏱️", color: "#EF4444" },
  CLIENT_FAVORITE:    { label: "Client Favorite",     emoji: "💖", color: "#EC4899" },
  INNOVATION:         { label: "Innovation Award",    emoji: "💡", color: "#A855F7" },
  CONSISTENCY:        { label: "Consistency Star",    emoji: "🎯", color: "#06B6D4" },
};

export const APPRECIATION_KEYS = Object.keys(APPRECIATION_TYPES);
